interface Product {
  supplierId: number
  nameNumber: string
}

export default class SupplierMultiSelect {
  multiSelectContainer: JQuery
  products: Product[]

  constructor(containerElement: HTMLElement) {
    this.multiSelectContainer = $(containerElement)


    this.updateSelectedProducts()
    if (this.multiSelectContainer.find('.option-product').length > 1 || this.multiSelectContainer.find('.option-supplier').length > 1) {
      this.initializeMultiSelect()
    } else {
      this.multiSelectContainer.addClass('static')
    }
  }

  private initializeMultiSelect(): void {
    // hide the product options initially
    this.multiSelectContainer.find('.product-options').hide()

    // Add event listener to open/close the dropdown
    this.multiSelectContainer.on('click', '.product-toggle', (event) => {
      event.preventDefault();
      $(event.currentTarget).toggleClass('open').siblings('.product-options').first().slideToggle()
    })

    // Add event listener select/unselect a supplier
    this.multiSelectContainer.on('click', '.option-supplier', (event) => {
      const supplierItem = $(event.currentTarget).parent()
      const isSelected = supplierItem.hasClass('selected')

      if (isSelected) {
        supplierItem.removeClass('selected')
        supplierItem.find('.option-product').removeClass('selected')
      } else {
        supplierItem.addClass('selected')
        const firstSupplierProduct = supplierItem.find('.option-product').first()
        // Only make changes if there are products to choose from
        if (firstSupplierProduct.length > 0) {
          firstSupplierProduct.addClass('selected')
          supplierItem.data('selected-product', firstSupplierProduct.text().trim())
        }
      }

      this.updateSelectedProducts()
    })

    // Add event listener select/unselect a product
    this.multiSelectContainer.on('click', '.option-product', (event) => {
      const productItem = $(event.currentTarget)
      const supplierItem = productItem.closest('.item')
      const isSelected = productItem.hasClass('selected')

      if (isSelected) {
        productItem.removeClass('selected')
        supplierItem.removeClass('selected')
      } else {
        productItem.siblings().removeClass('selected')
        productItem.addClass('selected')
        supplierItem.addClass('selected').data('selected-product', productItem.text().trim())
      }

      this.updateSelectedProducts()
    })
  }

  private updateSelectedProducts(): void {
    // Gather selected products and set the input value
    const products: Product[] = []
    this.multiSelectContainer.find('.item.selected').each((_, item) => {
      const id = $(item).data('id')
      const name = $(item).data('selected-product')

      products.push({supplierId: id, nameNumber: name})
    })
    this.products = products
    const inputValue = this.products.length ? JSON.stringify(this.products) : ""
    this.multiSelectContainer.find('input').val(inputValue)
  }
}